var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMalaysia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 36.571
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 36.571,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 36.571
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 73.14,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 36.571
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 109.71,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 36.571
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 146.29,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 36.571
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 182.86,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 36.571
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 219.43,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 36.571
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 256,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 36.571
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "512,329.143 0,329.143 0,269.474 13.474,269.474 13.477,292.571 512,292.571 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 329.14,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 36.571
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 365.71,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 36.571
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 402.29,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 36.571
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 438.86,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 36.571
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 475.43,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 36.571
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    style: {
      fill: "#41479B"
    },
    width: 292.57,
    height: 292.57
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M62.745,146.139c0-43.482,35.293-78.754,78.735-78.754c10.93,0,21.324,2.238,30.789,6.27 c1.229,0.523,2.154-1.187,1.05-1.938c-15.662-10.662-34.814-16.502-55.357-15.435C72.797,58.63,35.866,95.008,32.946,140.14 c-3.396,52.496,38.145,95.984,89.809,95.984c18.67,0,36.026-5.753,50.439-15.507c1.11-0.751,0.19-2.465-1.044-1.942 c-9.434,4-19.786,6.22-30.67,6.22C98.038,224.895,62.745,189.623,62.745,146.139"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M242.731,146.139l33.286-12.88c1.646-0.637,1.085-3.094-0.675-2.953l-35.565,2.848l24.441-26.125 c1.205-1.288-0.365-3.257-1.889-2.368l-30.889,18.02l10.661-34.09c0.526-1.683-1.743-2.775-2.729-1.313L219.376,116.9l-5.13-35.357 c-0.253-1.747-2.773-1.748-3.029-0.002l-3.277,22.372l-1.36,9.467l-0.523,3.52L186.06,87.303c-0.988-1.462-3.257-0.368-2.728,1.316 l10.701,34.062l-30.887-18.02c-1.524-0.889-3.094,1.08-1.889,2.368l24.439,26.126l-35.574-2.848 c-1.76-0.141-2.321,2.317-0.674,2.953l33.316,12.879l-33.317,12.882c-1.646,0.637-1.086,3.094,0.674,2.953l35.575-2.848 l-24.441,26.192c-1.204,1.29,0.37,3.256,1.892,2.365l30.885-18.084l-10.701,34.062c-0.529,1.683,1.741,2.778,2.728,1.316 l19.996-29.598l0.523,3.603l1.36,9.384l3.277,22.431c0.255,1.747,2.776,1.745,3.029-0.002l5.13-35.416l19.997,29.623 c0.987,1.462,3.256,0.37,2.729-1.313l-10.661-34.09l30.887,18.083c1.522,0.891,3.096-1.075,1.892-2.365l-24.442-26.192 l35.566,2.848c1.759,0.141,2.321-2.316,0.675-2.953L242.731,146.139z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalaysia);
export default __webpack_public_path__ + "static/media/malaysia.1f369aed81a13180817e0525475c5d0c.svg";
export { ForwardRef as ReactComponent };